/* eslint-disable */

/**
 * Copyright (c) Grab
 * Grab Design Tokens Project
 * Do not edit directly
 */

// [offsetX] [offsetY] [blur] [spread] [color]
export const duxtonDropShadowLevel1 = "0 6px 12px 0 #1c1c1c1a";
export const duxtonDropShadowLevel2 = "0 12px 24px 0 #1c1c1c1a";
export const duxtonDropShadowReversed = "0 -2px 12px 0 #1c1c1c1a";
